import PropTypes from 'prop-types';
import Text from '../../../../assets/styles/Text';
import FilterColumn from '../../../../components/FilterColumn';
import { useStore } from '../../../../stores';
import * as styles from './styles';

export default function Filters({
  showFilters,
  setShowFilters,
  activeFiltersCount,
  handleClearFilters,
  priceRange,
  filters,
  parseChoices,
}) {
  return (
    <styles.FiltersModal $show={showFilters}>
      <styles.FiltersOverlay onClick={() => setShowFilters(false)} />
      <styles.FiltersContent>
        <styles.FiltersHeader>
          <Text.H3>Filtros de Busca</Text.H3>
          <button
            type="button"
            onClick={() => setShowFilters(false)}
            className="close-btn"
          >
            ✕
          </button>
        </styles.FiltersHeader>

        {activeFiltersCount > 0 && (
          <styles.ClearFiltersButton onClick={handleClearFilters}>
            <Text.P>Limpar Filtros ({activeFiltersCount})</Text.P>
          </styles.ClearFiltersButton>
        )}

        <styles.FiltersBody>
          <styles.ValueFilterGroup>
            <Text.P>Filtrar por valor</Text.P>
            <styles.ValueInputs>
              <div>
                <label>De:</label>
                <input
                  type="number"
                  value={priceRange.min}
                  onChange={(e) => {
                    const { setPriceMin } = useStore.getState();
                    setPriceMin(e.target.value);
                  }}
                  placeholder="Mínimo"
                />
              </div>
              <div>
                <label>Até:</label>
                <input
                  type="number"
                  value={priceRange.max}
                  onChange={(e) => {
                    const { setPriceMax } = useStore.getState();
                    setPriceMax(e.target.value);
                  }}
                  placeholder="Máximo"
                />
              </div>
            </styles.ValueInputs>
          </styles.ValueFilterGroup>

          <styles.FiltersRow>
            <styles.FiltersColumn>
              <FilterColumn
                filters={filters?.leftColumn || []}
                parseChoices={parseChoices}
              />
            </styles.FiltersColumn>

            <styles.VerticalDivider />

            <styles.FiltersColumn>
              <FilterColumn
                filters={filters?.rightColumn || []}
                parseChoices={parseChoices}
              />
            </styles.FiltersColumn>
          </styles.FiltersRow>
        </styles.FiltersBody>
      </styles.FiltersContent>
    </styles.FiltersModal>
  );
}

Filters.propTypes = {
  showFilters: PropTypes.any.isRequired,
  setShowFilters: PropTypes.any.isRequired,
  activeFiltersCount: PropTypes.any.isRequired,
  handleClearFilters: PropTypes.any.isRequired,
  priceRange: PropTypes.any.isRequired,
  filters: PropTypes.any.isRequired,
  parseChoices: PropTypes.any.isRequired,
};
